<template>
  <v-row
    class="align-center my-3"
  >
    <v-col>
      <v-row>
        <v-col class="mx-3">
          <v-row class="font-weight-medium">
            <span>Dev Mode</span>
          </v-row>

          <v-row class="caption">
            View the app as a developer.
          </v-row>

          <v-row class="justify-space-between mb-6">
            <v-col class="pa-0 col-auto">
              <v-switch
                v-model="devMode"
                active-class="primary--text"
                class="mt-2"
                hide-details
                :label="devModeLabel"
                inset
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')

export default {
  computed: {
    ...mapAuthGetters([
      'inDevMode',
    ]),

    devMode: {
      get() {
        return this.inDevMode
      },
      set(newValue) {
        this.updateDevMode(newValue)
      },
    },
    devModeLabel() {
      return this.devMode ? 'On' : 'Off'
    },
  },

  methods: {
    updateDevMode(active) {
      const dev = { active }
      this.$store.dispatch('auth/updateDevMode', dev, { root: true })
    },
  },
}
</script>
